import { render, staticRenderFns } from "./Wizard-Contact.vue?vue&type=template&id=281668c4&scoped=true"
import script from "./Wizard-Contact.vue?vue&type=script&lang=ts"
export * from "./Wizard-Contact.vue?vue&type=script&lang=ts"
import style0 from "./Wizard-Contact.vue?vue&type=style&index=0&id=281668c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281668c4",
  null
  
)

export default component.exports